import{F as Y}from"./index-DCAZfSLJ.js";import{c as ee,r as te,t as se}from"./tagalys-widget-templates-CV2chhhv.js";import{o as re}from"./tagalys-init-s8-wkJQc.js";import"./index-WcD38sqt.js";const ie=d=>d?d.toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/-$/,"").replace(/^-/,""):null,E={widget:'[data-tagalys-widget="search-results"]',container:".search-container"},le=d=>{var L,f,w,C,F,k,R,I,P,T;const u=d==null?void 0:d.querySelector(E.widget);if(!u)return;window.localStorage.getItem("searchPageHref")!==window.location.search&&(window.localStorage.setItem("searchPageHref",window.location.search),window.localStorage.setItem("searchPageSelectedFilter","[]")),window.location.href.includes("?")||window.localStorage.setItem("searchPageSelectedFilter","[]");const h=u.dataset.limit??24,_=(L=u.dataset)==null?void 0:L.noResultsWidget,S=u.dataset.noResultsWidgetLimit??4;let p=window.localStorage.searchPageSelectedFilter!==void 0&&JSON.parse(window.localStorage.searchPageSelectedFilter).length>0?JSON.parse(window.localStorage.searchPageSelectedFilter):[];window.Tagalys.UIWidgets.SearchResults.init(E.widget,{templates:{widget:{options:{limit:h,includeTagalysCSS:!1},labels:{searchResults:{productsCount:"Items {{paginationStart}}-{{paginationEnd}} of {{productsCount}}",noResultsHeading:((C=(w=(f=window.theme)==null?void 0:f.strings)==null?void 0:w.search)==null?void 0:C.noResultsHeading)??"No results found, but here are some recommendations for you",heading:{standard:'{{resultsCount}} results for "{{searchTerm}}"',partialMatches:'Showing results for "{{searchTerm}}"',corrected:'Showing {{resultsCount}} results for "{{correctedSearchTerm}}" instead of "{{originalSearchTerm}}"'}},filters:{drawerFilterToggle:((R=(k=(F=window.theme)==null?void 0:F.strings)==null?void 0:k.collection)==null?void 0:R.filteringButton)??"Filter / Sort",heading:((T=(P=(I=window.theme)==null?void 0:I.strings)==null?void 0:P.collection)==null?void 0:T.filteringTitle)??"Filter"},pagination:{loading:"Loading...",loadNext:"Load More"}},render(s,t){const r=t.props.helpers,i=()=>{r.openFilterDrawer(),document.body.classList.add("filter-is-visible")},l=()=>{r.closeFilterDrawer(),document.body.classList.remove("filter-is-visible")};return r.handleFiltersDrawerOpen=i,r.handleFiltersDrawerClose=l,r.isInitialLoading()?s` <${t.templates.loader} /> `:r.hasNoSearchResults()&&!r.hasAnyFiltersApplied()?s` <${t.templates.noResults} /> `:(u.classList.remove("tagalys-widget--loading"),s`
            <div class="container container--fluid container--flush">
              <${t.templates.header} />
            </div>
            <div class="search__main-container pagination__container container" data-pagination-container>
              <form class="results-navbar" data-results-navbar="">
                <div class="results-navbar">
                  <${t.templates.productListHeader} />
                  <${t.templates.filters} />
                  ${r.isFilterDrawerOpen()?s` <div class="fader fader--filters" onclick=${r.handleFiltersDrawerClose} />`:null}

                  <${t.templates.products} />
                  <${t.templates.productListFooter} />
                </div>
              </form>
            </div>
          `)}},loader:{render(s){return s`<div class="search__loader"><div class="search__loader-indicator"></div></div>`}},header:{render(s,t){return s`
            <div class="search__header">
              <div class="search__header-inner">
                <${t.templates.searchForm} />
                <${t.templates.heading} />
              </div>
            </div>
          `}},heading:{render(s,t){const e=t.props,r=t.labels,i=e.helpers,a=i.isPartialResults()?r.searchResults.heading.partialMatches.replace("{{searchTerm}}",i.getQuery()):i.isSpellingCorrectedQuery()?r.searchResults.heading.corrected.replace("{{originalSearchTerm}}",i.getOriginalQuery()).replace("{{resultsCount}}",i.getTotalProductsCount()).replace("{{correctedSearchTerm}}",i.getQuery()):r.searchResults.heading.standard.replace("{{resultsCount}}",i.getTotalProductsCount()).replace("{{searchTerm}}",i.getQuery());return document.title=`Search: ${a}`,s`<h4 class="h4">${a}</h4>`}},searchForm:{render(s){var t,e;return s`
            <form class="search__form" action="${(e=(t=window.theme)==null?void 0:t.routes)==null?void 0:e.search}" method="get" role="search">
              <input
                type="search"
                class="search__input"
                name="q"
                id="Search"
                value=""
                placeholder="${window.theme.strings.search.placeholder}"
              />
              <button
                type="submit"
                class="search__button search__button-submit"
                aria-label="${window.theme.strings.search.submit}"
                data-submit-search
              >
                <svg
                  aria-label="Search icon"
                  class="icon icon--search"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.0002 15.0562L22.576 21.6319M15.95 5.05025C18.6837 7.78392 18.6837 12.2161 15.95 14.9497C13.2163 17.6834 8.78417 17.6834 6.0505 14.9497C3.31683 12.2161 3.31683 7.78392 6.0505 5.05025C8.78417 2.31658 13.2163 2.31658 15.95 5.05025Z"
                    stroke="currentColor"
                    stroke-width="1.2"
                    stroke-linecap="square"
                  />
                </svg>
              </button>
            </form>
          `}},productListHeader:{render(s,t){return s` <${t.templates.infoAndActions} /> `}},infoAndActions:{render(s,t){var N,W,O,q,D,V,z,J,Q,j,G,U,Z,K;const r=t.props.helpers;let i=((W=(N=window.theme)==null?void 0:N.settings)==null?void 0:W.brand_environment)||"default",l="";i==="gia"?(i="iamgia",l="data-grid-switcher-auto"):i==="tigermist"&&(l="data-grid-switcher-auto");const a=((O=window.theme)==null?void 0:O.collection)||{},n=a.includeFilters!==!1,o=a.showFilterIcon!==!1,y=a.includeLayoutSwitcher!==!1,x=a.includeGarmentImageSwitcher===!0,b=a.includeProductsPerPage!==!1,m=a.gridValues&&a.gridValues.length>0?a.gridValues:["3","5"],v=a.gridValuesMobile&&a.gridValuesMobile.length>0?a.gridValuesMobile:["1","2"],A=a.currentVendor||"",$=c=>{var g,M;return((M=(g=window.theme)==null?void 0:g.icons)==null?void 0:M[c])||""},H=()=>{var c,g,M,X;return((X=(M=(g=(c=window.theme)==null?void 0:c.strings)==null?void 0:g.collections)==null?void 0:M.filtering)==null?void 0:X.title)||"Filter / Sort"},B=()=>{let c="";return o&&(c+=$("icon-filter"),i==="tigermist"&&(c+=$("icon-filter"))),c+=H(),c};return s`
            <div class="results-navbar__row" data-results-navbar-row>
              ${A?s`<input type="hidden" name="q" value="${A}" />`:""}
              ${n?s`
                    <button
                      type="button"
                      class="btn btn--filter btn--none"
                      data-results-filter-toggle
                      onclick=${r.handleFiltersDrawerOpen}
                      innerHTML=${B()}
                    />
                  `:""}
              ${y?l?s`
                      <div class="grid-switcher__wrapper" data-grid-switcher-auto="">
                        ${m.length>0?s`
                              <div class="grid-switcher--desktop grid-switcher">
                                ${m.map((c,g)=>s`
                                    <button
                                      type="button"
                                      class="btn${g===0?" is-selected":""} btn--none"
                                      data-results-layout-switch="${c}"
                                      innerHTML=${i==="tigermist"?$(`icon-view-${c}`):c}
                                    />
                                  `)}
                              </div>
                            `:""}
                        ${v.length>0?s`
                              <div class="grid-switcher--mobile grid-switcher">
                                ${v.map((c,g)=>s`
                                    <button
                                      type="button"
                                      class="btn${g===1?" is-selected":""} btn--none"
                                      data-results-layout-switch-mobile="${c}"
                                      innerHTML=${i==="tigermist"?$(`icon-view-${c}`):c}
                                    />
                                  `)}
                              </div>
                            `:""}
                      </div>
                    `:s`
                      <div class="grid-switcher__wrapper">
                        ${m.length>0?s`
                              <div class="grid-switcher--desktop grid-switcher">
                                ${m.map((c,g)=>s`
                                    <button
                                      type="button"
                                      class="btn${g===0?" is-selected":""} btn--none"
                                      data-results-layout-switch="${c}"
                                      innerHTML=${i==="tigermist"?$(`icon-view-${c}`):c}
                                    />
                                  `)}
                              </div>
                            `:""}
                        ${v.length>0?s`
                              <div class="grid-switcher--mobile grid-switcher">
                                ${v.map((c,g)=>s`
                                    <button
                                      type="button"
                                      class="btn${g===1?" is-selected":""} btn--none"
                                      data-results-layout-switch-mobile="${c}"
                                      innerHTML=${i==="tigermist"?$(`icon-view-${c}`):c}
                                    />
                                  `)}
                              </div>
                            `:""}
                      </div>
                    `:""}
              ${x?s`
                    <div class="garment-image-switcher">
                      <button type="button" class="btn btn--garment-image-switcher" data-results-garment-image-switch>
                        <span>${((z=(V=(D=(q=window.theme)==null?void 0:q.strings)==null?void 0:D.collections)==null?void 0:V.filtering)==null?void 0:z.product)||"Product"}</span>
                        <span>${((G=(j=(Q=(J=window.theme)==null?void 0:J.strings)==null?void 0:Q.collections)==null?void 0:j.filtering)==null?void 0:G.model)||"Model"}</span>
                      </button>
                    </div>
                  `:""}
              ${b?s`
                    <div class="results-navbar__products-per-page">
                      <span data-pagination-viewed-clone>
                        ${r.getTotalProductsCount()} ${((K=(Z=(U=window.theme)==null?void 0:U.strings)==null?void 0:Z.pagination)==null?void 0:K.results)||"results"}
                      </span>
                    </div>
                  `:""}
            </div>
          `}},filters:{render(s,t){const r=t.props.helpers,i=r.getFilters(),l=r.isFilterDrawerOpen();return s`
            <div
              class="results-filter__drawer filters-drawer ${l?"is-visible":"is-hidden"}"
              aria-hidden="${!l}"
            >
              <div class="results-filter__drawer-inner">
                <div class="results-filter__header">
                  <div class="results-filter__title">
                    <p class="results-filter__header-title">${t.labels.filters.heading}</p>
                    <button type="button" class="btn--none btn--close" onclick=${r.handleFiltersDrawerClose}>
                      <svg
                        aria-label="Cross icon"
                        class="icon icon--cross"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-width="1.5"
                          vector-effect="non-scaling-stroke"
                          d="M17 7L7 17M7 7l10 10"
                        ></path>
                      </svg>
                    </button>
                  </div>
                  <ul class="results-filter__active-filters">
                    <${t.templates.selectedFilters} />
                  </ul>
                </div>

                <div class="results-filter__row">
                  <div class="accordion">
                    <${t.templates.sortOptionsFilter} />
                    ${i.map(a=>s`<${t.templates.filter} filter=${a} />`)}
                  </div>
                </div>

                <${t.templates.filtersFooter} />
              </div>
            </div>
          `}},sortOptionsFilter:{render(s,t){var n;const r=t.props.helpers,i=r.getSortOptions(),l=r.getAppliedSortOption(),a=r.isCollapsibleFilterExpanded("sort_by");return s`
            <div class="accordion__label" role="heading">
              <button
                type="button"
                class="accordion__trigger btn-none"
                id="accordion-trigger-1-filter"
                aria-controls="accordion-panel-1-filter"
                aria-expanded="${a}"
                onclick=${()=>r.toggleCollapsibleFilter("sort_by")}
              >
                Sort
                <span class="accordion__trigger-indicator">
                  <svg
                    aria-label="Chevron right icon"
                    class="icon icon--chevron-right"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M6 5L10 8L6 11" stroke="currentColor"></path>
                  </svg>
                </span>
              </button>
            </div>
            <div
              class="accordion__panel"
              id="accordion-panel-1-filter"
              role="region"
              aria-labelledby="accordion-trigger-1-filter"
              style="height: ${a?`${((n=document.getElementById("accordion-panel-1-filter"))==null?void 0:n.scrollHeight)||"auto"}px`:"0px"};"
            >
              <div class="accordion__body">
                <div data-results-filter-content="">
                  <ul class="results-filter__filter-list">
                    ${i.map(o=>s`
                        <li class="results-filter__filter-value results-filter__filter-value--sort">
                          <input
                            type="radio"
                            name="sort_by"
                            value="${o.id}"
                            id="Sort-${o.id}"
                            data-results-filter-sort-value=""
                            ${l.id===o.id?"checked":""}
                            onchange=${()=>r.applySortOption(o.id)}
                          />
                          <label for="Sort-${o.id}">${o.label}</label>
                        </li>
                      `)}
                  </ul>
                </div>
              </div>
            </div>
          `}},filter:{render(s,t){var b,m,v;const e=t.props,r=e.helpers,i=ie(e.filter.id),l=e.filter.name.toLowerCase(),a=r.isCollapsibleFilterExpanded(e.filter.id),n=l==="tags"?"visually-hidden":"",o=((m=(b=window.theme)==null?void 0:b.collection)==null?void 0:m.filtersWithSwatches)??[],y=o.includes(l),x=o.includes(l)||l.includes("size")?"grid":"list";return s`
            <div class="accordion__label ${n}" role="heading">
              <button
                type="button"
                class="accordion__trigger btn-none"
                id="accordion-trigger-${e.filter.id}-filter"
                aria-controls="accordion-panel-${e.filter.id}-filter"
                aria-expanded="${a}"
                onclick=${()=>r.toggleCollapsibleFilter(e.filter.id)}
              >
                ${e.filter.name}${n?" [Hidden]":""}
                <span class="accordion__trigger-indicator">
                  <svg
                    aria-label="Chevron right icon"
                    class="icon icon--chevron-right"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M6 5L10 8L6 11" stroke="currentColor"></path>
                  </svg>
                </span>
              </button>
            </div>
            <div
              class="accordion__panel ${n}"
              id="accordion-panel-${e.filter.id}-filter"
              role="region"
              aria-labelledby="accordion-trigger-${e.filter.id}-filter"
              style="height: ${a?`${((v=document.getElementById(`accordion-panel-${e.filter.id}-filter`))==null?void 0:v.scrollHeight)||"auto"}px`:"0px"};"
            >
              <div class="accordion__body">
                <div data-results-filter-content="">
                  ${e.filter.type==="checkbox"?s`<${t.templates.filterCheckBoxes}
                        filterHandle=${i}
                        filterId=${e.filter.id}
                        filterItems=${e.filter.items}
                        filtersLayout=${x}
                        hasSwatches=${y}
                      />`:s`<${t.templates.rangeSliderFilterItem} filter=${e.filter} />`}
                </div>
              </div>
            </div>
          `}},selectedFilters:{render(s,t){const e=t.props.helpers,r=i=>{i.stopPropagation();const l=i.target.dataset.filterId,a=p.findIndex(o=>o.filterItem.id===l),n=p[a];p.splice(a,1),window.localStorage.setItem("searchPageSelectedFilter",JSON.stringify(p)),e.clearFilter(n.filterId,n.filterItem.id)};return p.map(i=>s`
              <li>
                <button
                  type="button"
                  class="results-filter__active-filter"
                  data-filter-id=${i.filterItem.id}
                  onclick=${r}
                >
                  ${i.filterItem.name.toLowerCase()}
                  <svg
                    aria-label="Cross icon"
                    class="icon icon--cross"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-width="1.5"
                      vector-effect="non-scaling-stroke"
                      d="M17 7L7 17M7 7l10 10"
                    ></path>
                  </svg>
                </button>
              </li>
            `)}},checkboxFilterItem:{render(s,t){const e=t.props,r=e.helpers,i=l=>{var a;if(l.stopPropagation(),e.filterItem.selected){const n=p.findIndex(o=>o.filterItem.id===e.filterItem.id);p.splice(n,1),window.localStorage.setItem("searchPageSelectedFilter",JSON.stringify(p)),r.clearFilter(e.filterId,e.filterItem.id)}else if(r.applyFilter(e.filterId,e.filterItem.id),(a=document.querySelector("[data-results-filter-selected]"))==null||a.classList.add("active"),!p.find(o=>o.filterItem.id===e.filterItem.id)){const o={filterId:e.filterId,filterItem:e.filterItem};p.push(o),window.localStorage.setItem("searchPageSelectedFilter",JSON.stringify(p))}window.localStorage.setItem("searchPageHref",window.location.search)};return s`
            <input
              id="Filter-${e.filterHandle}-${e.index}"
              type="checkbox"
              name="${e.filterId}"
              value="${e.filterItem.name}"
              checked=${e.filterItem.selected}
              onclick=${i}
            />
            <label for="Filter-${e.filterHandle}-${e.index}" onclick=${i}>
              ${e.hasSwatches?s`<span class="swatch swatch--" style="background-color: #000000;"></span>`:""}
              ${e.filterItem.name}
              <span class="results-filter__filter-value-count">(${e.filterItem.count||0})</span>
            </label>
          `}},filterCheckBoxes:{render(s,t){const e=t.props,r=e.filterItems||[],i=e.filterHandle||"",l=e.filterId||"",a=e.hasSwatches||!1;return s`
            <ul class="results-filter__filter-list">
              ${r.map((n,o)=>s`
                  <li class="results-filter__filter-value${a?" results-filter__filter-value--color":""}">
                    <${t.templates.checkboxFilterItem}
                      filterItem=${n}
                      filterHandle=${i}
                      filterId=${l}
                      index=${o}
                      hasSwatches=${a}
                    />
                  </li>
                `)}
            </ul>
          `}},rangeSliderFilterItem:{render(s,t){var i,l,a,n;const e=t.props,r=e.helpers;return s`
            <div ref=${e.sliderRef} />
            <div class="results-filter__filter-range">
              <div class="results-filter__filter-range-from">
                <span>${(l=(i=window.theme)==null?void 0:i.localization)==null?void 0:l.currencySymbol}</span>
                <input
                  type="number"
                  value=${e.sliderInputValues[0]}
                  placeholder="From"
                  aria-label="From ${r.labelFormatter(e.filter.display_format,e.filter.min,e.filter.currency)}"
                  onblur=${e.onInputBlur}
                  onchange=${e.onMinChange}
                />
              </div>

              <div class="results-filter__filter-range-to">
                <span>${(n=(a=window.theme)==null?void 0:a.localization)==null?void 0:n.currencySymbol}</span>
                <input
                  type="number"
                  value=${e.sliderInputValues[1]}
                  placeholder="To"
                  aria-label="To ${r.labelFormatter(e.filter.display_format,e.filter.max,e.filter.currency)}"
                  onblur=${e.onInputBlur}
                  onchange=${e.onMaxChange}
                />
              </div>
            </div>
          `}},filtersFooter:{render(s,t){const r=t.props.helpers,i=r.getTotalProductsCount(),l=()=>{r.clearAllFilters(),p=[],window.localStorage.removeItem("searchPageSelectedFilter")};return s`
            <div class="results-filter__footer" data-results-filter-footer="">
              <button type="submit" class="btn no-js">Apply</button>
              <a
                href="?${window.location.search.replace(/[?&]filter\.[^&]+/g,"")}"
                class="results-filter__clear-link btn btn--secondary"
                data-results-filter-clear-link=""
                data-text="Clear all"
                onclick=${l}
              >
                Clear all
                <svg
                  aria-label="Cross icon"
                  class="icon icon--cross"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-width="1.5"
                    vector-effect="non-scaling-stroke"
                    d="M17 7L7 17M7 7l10 10"
                  ></path>
                </svg>
              </a>

              <button
                class="btn btn--primary btn--apply"
                data-results-filter-toggle=""
                type="button"
                onclick=${r.handleFiltersDrawerClose}
              >
                Apply (<span class="results-filter__apply-count" data-results-count="">${i}</span>)
              </button>
            </div>
          `}},products:{render(s,t){const i=t.props.helpers.getProducts();return s`
            <div class="search__results">
              <ul
                class="results-grid results-grid--default list-inline m-results-grid--2"
                data-grid
                data-results-grid
                data-layout-mobile="2"
                data-layout-desktop="4"
                data-layout-mobile-alt="1"
                data-layout-desktop-alt="3"
              >
                ${i.map(l=>s`<${t.templates.product} key=${l.id} product=${l} />`)}
              </ul>
            </div>
          `},callbacks:{afterEveryRender:()=>{const s=u.querySelectorAll("[data-slider]");s==null||s.forEach(t=>{const e=Y.data(t);e==null||e.resize()})}}},product:{options:{productPageUrl(s){return ee(s)}},render(s,t){const e=t.props,r=e.product,i=e.helpers;return s`<li class="results-grid__tile" innerHTML=${te(r,i)} />`}},productListFooter:{render(s,t){return s` <${t.templates.pagination} /> `}},pagination:{options:{infiniteScroll:!0,showLoadNextAfterEvery:1},render(s,t){const e=t.props,r=e.helpers;return e.infiniteScroll?r.canLoadNextResults(e.showLoadNextAfterEvery)?s`<div class="pagination pagination-nav"><${t.templates.loadNext} /></div>`:null:s`<div class="pagination"><${t.templates.paginationLinks} /></div>`}},loadNext:{render(s,t){var b,m,v,A,$,H,B;const e=t.props,r=e.helpers,i=t.labels,l=r.getTotalPages(),a=r.getCurrentPage(),n=r.getTotalProductsCount(),o=a===l?n:a*h,y=o*100/n,x=(B=(v=(m=(b=window.theme)==null?void 0:b.strings)==null?void 0:m.pagination)==null?void 0:v.progress)==null?void 0:B.replace("{{ count }}",o).replace("{{ total }}",n).replace("{{ results }}",(H=($=(A=window.theme)==null?void 0:A.strings)==null?void 0:$.pagination)==null?void 0:H.results);return s`
            <div class="pagination__load-next">
              <p class="pagination__header">${x}</p>
              <div class="pagination__progress">
                <div class="pagination__progress-bar" style="width: ${y}%;"></div>
              </div>
              <button class="btn" onClick=${e.helpers.loadNextPage}>
                ${r.isLoading()?i.pagination.loading:i.pagination.loadNext}
              </button>
            </div>
          `}},paginationLinks:{options:{showNumberedPageLinks:!0,numberedPageLinksWindowSize:3,showPreviousPageLink:!0,showFirstPageLink:!1,showNextPageLink:!0,scrollTop:!0},render(s,t){const e=t.props,r=e.helpers,i=r.getPagesToDisplay(e.numberedPageLinksWindowSize),l=r.getCurrentPage(),a=r.hasPreviousPage(),n=r.hasNextPage();return s`
            <ol class="pagination">
              ${e.showPreviousPageLink?s`
                    <li>
                      <button
                        class=${`pagination__arrow btn-none${a?"":" disabled"}`}
                        onclick=${l===1?void 0:r.goToPreviousPage}
                      >
                        <svg
                          aria-label="Chevron left icon"
                          class="icon icon--chevron-left"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="1.2" stroke-linecap="square" />
                        </svg>
                      </button>
                    </li>
                  `:null}
              ${e.showNumberedPageLinks?i.map(o=>{const y=["pagination__page pagination__page-link btn-none"],x=o.jumpAfter;o.current&&y.push("pagination__page--active");const b=y.join(" ");return x?s`
                        <li>
                          <span class="pagination__page">...</span>
                        </li>
                      `:s`
                      <li>
                        <button
                          class=${`${b}`}
                          onclick=${()=>{r.goToPage(o.page)}}
                        >
                          ${o.page}
                        </button>
                      </li>
                    `}):null}
              ${e.showNextPageLink?s`
                    <li>
                      <button
                        class=${`pagination__arrow btn-none${n?"":" disabled"}`}
                        onclick=${n?r.goToNextPage:void 0}
                      >
                        <svg
                          aria-label="Chevron right icon"
                          class="icon icon--chevron-right"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="1.2" stroke-linecap="square" />
                        </svg>
                      </button>
                    </li>
                  `:null}
            </ol>
          `}},noResults:{options:{widgets:[{widgetId:_,options:{templates:se(S,u)}}]},render(s,t){const e=t.labels;return s`
            <div class="container container--fluid container--flush">
              <div class="search__header">
                <div class="search__header-inner">
                  <${t.templates.searchForm} />
                  <h4 class="h4">${e.searchResults.noResultsHeading}</h4>
                </div>
              </div>
            </div>
            <div class="no-results__container container container--fluid">
              <${t.templates.noResultsWidgets} />
            </div>
          `}},noResultsWidgets:{render(s,t){return _?s`<div class="no-results__widgets">
            <${t.templates.widgets} />
          </div>`:s`<div class="no-results__message">
              <p>No products found matching your search criteria.</p>
            </div>`}}},callbacks:{onSuccessfulAPICall(s){return s.redirect_to_url&&s.redirect_to_url.startsWith("/")&&(s.redirect_to_url=s.redirect_to_url.replace(/^\/(.*)/,`${window.Shopify.routes.root}$1`)),s},afterEveryRender(){ae()}}})},ue=()=>{re(()=>{let d=document.querySelector(E.container);le(d),setTimeout(()=>{document.dispatchEvent(new Event("tagalys:ready"))},1e3)})};function ae(){const d=document.querySelector(E.container),u=d==null?void 0:d.querySelector("[data-results-grid]"),h=document.querySelector("[data-pagination-container]"),_=d==null?void 0:d.querySelectorAll("[data-results-layout-switch]"),S=d==null?void 0:d.querySelectorAll("[data-results-layout-switch-mobile]"),p=d==null?void 0:d.querySelector("[data-grid-switcher-auto]");if(!u||!_.length&&!S.length)return;const L={isSelected:"is-selected"};let f="",w="";const C=Array.from(u.classList).find(t=>t.startsWith("results-grid--")),F=Array.from(u.classList).find(t=>t.startsWith("m-results-grid--"));C&&(f=C.replace("results-grid--","")),F&&(w=F.replace("m-results-grid--",""));function k(t,e=!1){const r=e?t.dataset.resultsLayoutSwitchMobile:t.dataset.resultsLayoutSwitch;e?w=r:(f=r,window.sessionStorage.setItem("resultsLayoutView",r)),R(),(e?S:_).forEach(l=>{l.setAttribute("aria-pressed","false"),l.removeAttribute("disabled"),l.classList.remove(L.isSelected)}),t.setAttribute("disabled","disabled"),t.setAttribute("aria-pressed","true"),t.classList.add(L.isSelected)}function R(){if(!u)return;const t=Array.from(u.classList).filter(e=>e.startsWith("results-grid--")||e.startsWith("m-results-grid--"));if(u.classList.remove(...t),f&&u.classList.add(`results-grid--${f}`),w&&u.classList.add(`m-results-grid--${w}`),h){const e=Array.from(h.classList).filter(r=>r.startsWith("results-grid--")||r.startsWith("m-results-grid--"));h.classList.remove(...e),f&&h.classList.add(`results-grid--${f}`),w&&h.classList.add(`m-results-grid--${w}`)}}if(f==="alt"){const t=[..._].find(e=>e.dataset.resultsLayoutSwitch==="alt");t&&k(t)}const I=[...S].find(t=>t.dataset.resultsLayoutSwitchMobile===w);I&&(I.setAttribute("disabled","disabled"),I.setAttribute("aria-pressed","true"),I.classList.add(L.isSelected)),p&&(p.removeEventListener("click",s),p.addEventListener("click",s)),_.forEach(t=>{t.removeEventListener("click",P),t.addEventListener("click",P)}),S.forEach(t=>{t.removeEventListener("click",T),t.addEventListener("click",T)});function P(t){k(t.target,!1)}function T(t){k(t.target,!0)}function s(){const t=window.matchMedia("(max-width: 990px)").matches,e=t?S:_,i=(Array.from(e).findIndex(l=>l.classList.contains(L.isSelected))+1)%e.length;h&&(h.classList.add("is-transitioning"),setTimeout(()=>{h.classList.remove("is-transitioning")},250)),setTimeout(()=>{k(e[i],t)},250)}}export{ue as i};
